import React from 'react';
import { FormattedMessage } from 'react-intl';

import Link from '../Link';
import { ButtonText, Overline } from '../Typography';

import styles from './index.module.scss';

export interface AddToCartButtonProps {
  selectedProducts: string[];
  isOnlyOneProduct?: boolean;
  urlAttributes?: string;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  selectedProducts,
  isOnlyOneProduct,
  urlAttributes,
}) => {
  let cartURL = '';

  if (selectedProducts.length > 0) {
    const formattedProducts = selectedProducts
      .map((productId) => `${productId}:1`)
      .join(',');

    const urlAttributesData = urlAttributes ? `&${urlAttributes}` : '';

    cartURL = `https://hy-demo.myshopify.com/cart/${formattedProducts}?channel=buy_button${urlAttributesData}`;
  }

  return (
    <Link url={cartURL} disabled={!cartURL} className={styles.wrapper}>
      <ButtonText>
        <FormattedMessage
          id='actions.add-to-basket'
          defaultMessage='Add to cart'
        />
      </ButtonText>

      {!isOnlyOneProduct && (
        <Overline>
          <FormattedMessage
            id='check-ups.add-items'
            defaultMessage='{count, plural, 
              =0 {No items added}
              one {# item added}
              other {# items added}
            }'
            values={{ count: selectedProducts.length }}
          />
        </Overline>
      )}
    </Link>
  );
};

export default AddToCartButton;
